// © Microsoft Corporation. All rights reserved.

import { requireAsync } from "./RequireAsync";

/**
 * Integration function to retrieve the prime track object.
 *
 * @export
 * @return {Promise<PrimeGlobal.IElementTrackingDecorator>} - Resolves if the track object could be loaded, rejects otherwise.
 */
export const getElementTrackingDecorator: IGetElementTrackingDecorator = () => {
    return requireAsync<PrimeGlobal.IElementTrackingDecorator>("elementTrackingDecorator");
};
